/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


import Vue from 'vue'
import Vuex from 'vuex';

import store from './store/store'

require('./bootstrap');
require('./validators');
require('./acl');

import axios from './axios'
import VueI18n from 'vue-i18n'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import {BootstrapVue, IconsPlugin, BootstrapVueIcons} from 'bootstrap-vue'
import {BVToastPlugin} from 'bootstrap-vue'
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import router from './router'
import messages from './messages'
import StorePlugin from "./utils/store-plugin";
import {api} from './utils/api'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import TaskTreeItem from './pages/Tree/components/TaskTreeItem'
import feather from 'vue-icon'
import Echo from "laravel-echo"
import _ from 'lodash'
import 'vue2-datepicker/index.css';
import VueCookies from 'vue-cookies';
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css' // import the croppie css manually

// Events bus
export const eventBus = new Vue();

// Application styles
import './sass/app.scss';

// Import the app
import App from './App.vue'

// Setup websockets channels
window.Pusher = require('pusher-js');
//window.Pusher.logToConsole = true;

// Set vuew
window.Vue = Vue;

// set axios
Vue.prototype.$http = axios;
Vue.prototype.$api = api;

Vue.use(VueCroppie);

// init router
Vue.router = router;
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(_);
Vue.use(VueCookies);
Vue.use(BootstrapVueIcons)
Vue.use(StorePlugin);
Vue.use(feather, 'v-icon');
Vue.use(require('vue-moment'));
Vue.use(BVToastPlugin)

// init http
Vue.use(VueAxios, axios);
// init i18n
const i18n = new VueI18n({
    locale: 'en',
    messages,
});
// init validation
Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);

// global register font awesome component
Vue.component('font-awesome-icon', FontAwesomeIcon);

// init state store
Vue.use(Vuex);

// Load Index
Vue.component('app', () => import('./App.vue'));
Vue.component('task-tree-item', TaskTreeItem);

// Vue directives
Vue.directive('click-outside', {
    bind () {
        this.event = event => this.vm.$emit(this.expression, event)
        this.el.addEventListener('click', this.stopProp)
        document.body.addEventListener('click', this.event)
    },
    unbind() {
        this.el.removeEventListener('click', this.stopProp)
        document.body.removeEventListener('click', this.event)
    },

    stopProp(event) { event.stopPropagation() }
})

// Set timeout for device ready
let ftm = setTimeout(() => startEngine(), 6000);

// Wait for device ready and start engine
let startEngine = () => {

    // Clear timeout
    if (ftm) clearTimeout(ftm);

    // Create app
    window.app = new Vue({
        el: '#app',
        render: h => h(App),
        router,
        i18n,
        store
    });

    // Allow devtools
    //Vue.config.devtools = true;

    // Default proto
    let transps = ["wss"];

    //   Protocals
    //if(process.env.MIX_PUSHER_APP_SCHEME === 'http')
    transps = ['ws'];

    // Create echo
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.VUE_APP_PUSHER_APP_KEY,
        wsHost: process.env.VUE_APP_WS_URL,
        authEndpoint : process.env.VUE_APP_WS_AUTH_URL,
        wsPort: process.env.VUE_APP_WS_PORT,
        wssPort: process.env.VUE_APP_WS_PORT,
        disableStats: true,
        enabledTransports: transps,
        auth: {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
            }
        }
    });

    // Set update time
    window.lastConnected = window.app.$api.getUnixTime() + 10;

    // Connect listener
    window.Echo.connector.pusher.connection.bind('connected', () => {

        // Get current time
        let ct = window.app.$api.getUnixTime();

        // Check for disconnect time
        if (ct - window.lastConnected > 5) {
            // Load window
            window.location.reload();
        }

        // Set connected
        window.lastConnected = ct;
    });

    // Preflight
    //axios.get("/api/preflight");

};

// Start engine directly or through listener
if (typeof window.cordova !== 'undefined') {
    document.addEventListener('deviceready', () => {
        // Start engine
        startEngine();
    });
} else startEngine()
